<div class="header-icon" *appHasPermission="{ resource: Resources.Notifications, scope: Scopes.Read }">
  <button
    mat-icon-button
    [matMenuTriggerFor]="notificationMenu"
    [class]="'notification-button ' + getConnectionClass()"
    [matBadge]="unreadBadge"
    [matBadgeHidden]="unreadCount === 0"
    matBadgeColor="warn"
    matBadgeSize="small"
    >
    <mat-icon
      [ngClass]="{
        rotating:
          connectionState === hubConnectionState.Connecting || connectionState === hubConnectionState.Reconnecting,
      }"
      >
      {{ getConnectionIcon() }}
    </mat-icon>
  </button>
  <mat-menu #notificationMenu="matMenu" class="notification-menu">
    <div class="notification-content-wrapper" (click)="$event.stopPropagation()">
      <div class="notification-header">
        <span>Notifications</span>
        <button mat-icon-button class="close-btn" (click)="closeMenu()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="notification-tabs">
        @for (tab of notificationTabs; track tab) {
          <span
            (click)="$event.stopPropagation(); onSelectTab(tab)"
            [ngClass]="{ selected: selectedNotificationTab === tab }"
            >
            {{ labelForTab(tab) }}
          </span>
        }
      </div>
      <mat-divider class="notification-divider"></mat-divider>
      @if (hasUnreadNotifications) {
        <div class="read-all-button">
          <img src="shared-assets/icons/ticks-icon.svg" alt="" aria-hidden="true" />
          <p (click)="markAllAsRead($event)">Mark all as read</p>
        </div>
      }
      @if (hasNotifications) {
        <div class="notifications-container">
          @for (notification of displayNotifications; track notification.id) {
            <div
              class="notification-item"
              (click)="onSpecificNotificationClick(notification)"
              [class.unread]="!notification.isRead"
              >
              <div class="notification-content">
                <div class="notification-message">{{ notification.message }}</div>
                <!-- New pill for task type -->
                @if (notification.taskType) {
                  <div class="notification-task-type">
                    {{ notification.taskType }}
                  </div>
                }
                <div class="notification-time">{{ formatNotificationTime(notification.timestamp) }}</div>
              </div>
              @if (!notification.isRead) {
                <div class="notification-type-indicator"></div>
              }
            </div>
          }
          <app-show-more
            [isShowMore]="hasMoreNotifications"
            [isLoading]="false"
          [text]="{
            loadingText: '',
            showMoreText: `Show More (${totalNotificationsCount})`,
          }"
            (loadMore)="showMore()"
            >
          </app-show-more>
        </div>
      } @else {
        <div class="no-notifications">
          <mat-icon>notifications_none</mat-icon>
          <span>No notifications</span>
        </div>
      }
    </div>
  </mat-menu>
</div>
